import * as actionTypes from "../constants";
import * as apis from "../requests/apis";
import * as payloads from "../requests/payloads";
import * as services from "../services";
import { clientRequest, contentHeader } from "../requests";
import { showToast, TOAST_TYPE } from "utils/toast";

// Behavioural Form — the detailed daily journal (meal times, sleep,
// exercise, hobbies), a separate resource from the simple score record in
// redux/actions/behavioural.js. Unlike that one, this is a real list: each
// submission adds a new dated entry rather than upserting a single record.

// Get past entries in a date range (defaults to the last 30 days)
export const getBehaviouralForms = (dates) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.FETCH_BEHAVIOURAL_FORMS });
    const toDate = dates?.toDate || new Date().toISOString();
    const fromDate =
      dates?.fromDate || new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
    const res = await clientRequest(
      actionTypes.POST,
      apis.GET_BEHAVIOURAL_FORMS_API,
      { userId: services.getUser(), fromDate, toDate },
      contentHeader
    );
    dispatch({
      type: actionTypes.GET_BEHAVIOURAL_FORMS_SUCCESS,
      payload: Array.isArray(res.data) ? res.data : [],
    });
  } catch (err) {
    dispatch({
      type: actionTypes.GET_BEHAVIOURAL_FORMS_FAIL,
      payload: err,
    });
  }
};

// Submit a new journal entry
export const createBehaviouralForm = (form) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SAVING_BEHAVIOURAL_FORM });
    const payload = payloads.behaviouralFormPayload(form);
    await clientRequest(actionTypes.POST, apis.CREATE_BEHAVIOURAL_FORM_API, payload, contentHeader);
    showToast("Behavioural form saved.", TOAST_TYPE.success);
    dispatch({ type: actionTypes.SAVE_BEHAVIOURAL_FORM_SUCCESS });
  } catch (err) {
    showToast(err?.response?.data || "Failed to save behavioural form.", TOAST_TYPE.error);
    dispatch({
      type: actionTypes.SAVE_BEHAVIOURAL_FORM_FAIL,
      payload: err,
    });
  }
};
